import AuthService from '@services/auth.service';
import {START_FULL_PAGE_LOADER, STOP_ALL_LOADERS} from '@store/loader/actions';
import {detectPlatform, detectBrowser} from '@services/helper.service';
import router from '../../routes/routes';

const state = {
    register_form: {
        role: '',
        fname: '',
        lname: '',
        email: '',
        password: '',
        method: '',
        lang: '',
        tz: new Date().getTimezoneOffset()
    },
    isSSOLogin: false,
    isSocialLogin: null // will be set google, facebook, harid
};

const mutations = {
    ['UPDATE_REGISTER_FORM'](state, { role, country, method, data }) {
        if(role) {
            state.register_form.role = role;
            localStorage.setItem('register_role', role);
        }
        if(country) {
            state.register_form.country = country;
            localStorage.setItem('register_country', country);
        }
        if(method) {
            state.register_form.method = method;
        }
        if(data) {
            state.register_form.fname = data.fname;
            state.register_form.lname = data.lname;
            state.register_form.email = data.email;
            state.register_form.password = data.password;
        }
    },
    ['RESET_REGISTER_FORM'](state) {
        state.register_form = {
            role: '',
            fname: '',
            lname: '',
            email: '',
            password: '',
            method: '',
            lang: '',
            tz: new Date().getTimezoneOffset()
        };
    },
    ['SET_SSO_LOGIN'] (state, status) {
        state.isSSOLogin = status;
    },
    ['SET_SOCIAL_LOGIN'](state, status) {
        state.isSocialLogin = status;
    },
    ['RESET_LOGIN_STATUS'] (state) {
        state.isSSOLogin = false;
        state.isSocialLogin = null;
    }
};

const actions = {
    ['SOCIAL_LOGIN']({ getters, commit }, data) {
        const role = localStorage.getItem('register_role');
        const country = localStorage.getItem('register_country');

        commit(START_FULL_PAGE_LOADER);
        if (role && role !== '') {
            data.role = role;
        }
        if (country && country !== '') {
            data.country = country;
        }
        data.lang = getters.language;
        data.tz = new Date().getTimezoneOffset();
        return AuthService.socialLogin(data).then(res => {
            commit(STOP_ALL_LOADERS);
            if(res) {
                return res;
            }
        });
    },
    ['LOGIN']({ commit }, data) {
        commit(START_FULL_PAGE_LOADER);
        return AuthService.login(data).then(res => {
            if(res) {
                return res;
            }

            commit(STOP_ALL_LOADERS);
        });
    },
    ['2FA_LOGIN'] ({commit, getters}, data) {
        commit(START_FULL_PAGE_LOADER);
        return AuthService.login2FA(data).then(res => {
            commit(STOP_ALL_LOADERS);
            if(res.status === 'valid') {
                let proceed = 'dashboard';
                if(getters.isSSOLogin && getters.isSocialLogin) {
                    proceed = 'sso_auth';
                } else if(getters.isSSOLogin) {
                    //Redirect will be done by 2fa landing with the query data
                    proceed = '';
                }

                AuthService.getUserAndPermissions(data.platform, proceed, 'login');
            }
            return res;
        });
    },
    ['LOGIN_AS'](context, id) {
        AuthService.loginAs(id);
    },
    ['LOGOUT']({ commit }, redirectPath) {
        commit(START_FULL_PAGE_LOADER);
        AuthService.logout(redirectPath);
    },
    ['LOGOUT_AS']({ commit }, id) {
        commit(START_FULL_PAGE_LOADER);
        AuthService.logoutAs(id).then(() => {
            router.replace('/dashboard', () => {
                    location.reload();
                },
                () => {
                    location.reload();
                });
            commit(STOP_ALL_LOADERS);
        });
    },
    ['REGISTER_USER']({ getters, commit }) {
        commit(START_FULL_PAGE_LOADER);
        const data = getters.registerForm;
        data.lang = getters.language;
        return AuthService.registerUser(data).then(res => {
            commit(STOP_ALL_LOADERS);
            commit('RESET_REGISTER_FORM');
            return res;
        });
    },
    ['REGISTER_EMPLOYEE_USER']({ dispatch, commit, getters }, data) {
        data.lang = getters.language || 'en';
        data.tz = new Date().getTimezoneOffset();
        return AuthService.registerEmployeeUser(data).then(() => {
            const form = {
                username: data.email,
                password: data.password,
                platform: {
                    platform: detectPlatform(),
                    browser: detectBrowser(),
                    login: 'password'
                }
                // platform: [detectPlatform(), detectBrowser(), 'password']
            };
            commit('RESET_REGISTER_FORM');
            dispatch('LOGIN', form).then(res => {
                return res;
            });
        });
    }
};

const getters = {
    registerForm: state => {
        return state.register_form;
    },
    isSSOLogin: state => state.isSSOLogin,
    isSocialLogin: state => state.isSocialLogin
};

export default {
    state,
    mutations,
    actions,
    getters
};
